// extracted by mini-css-extract-plugin
export default {"title":"Unsubscribe_title__RKdUq"};